import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { MedicoDeficienciaRequest, MedicoDeficienciaResponse, MedicoPeriodoResponse, MedicoRequest, MedicoResponse } from '@/core/api/sicom-api/registro/medico/medico.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class MedicoService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.medico.base;
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    buscar(params: Pessoa, context?: HttpContext): Observable<MedicoRequest> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<MedicoRequest>(this.PATH, { params: httpParams, context });
    }

    atualizar(body: MedicoRequest, context?: HttpContext): Observable<MedicoResponse> {
        return this.http.put<MedicoResponse>(this.PATH, body, { context });
    }

    listarSuspensoes(params: Pessoa, context?: HttpContext): Observable<MedicoPeriodoResponse[]> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<MedicoPeriodoResponse[]>(`${this.PATH}/suspensoes`, { params: httpParams, context });
    }

    listarDeficiencias(params: Pessoa, context?: HttpContext): Observable<MedicoDeficienciaResponse[]> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<MedicoDeficienciaResponse[]>(SICOM_PATHS.registro.medico.deficiencia, { params: httpParams, context });
    }

    salvarDeficiencia(body: MedicoDeficienciaRequest, context?: HttpContext): Observable<void> {
        return this.http.post<void>(SICOM_PATHS.registro.medico.deficiencia, body, { context });
    }
}
